import { useEffect, useState } from 'react';

import Api from 'api';
import ContentBox from 'layout/atoms/ContentBox';

const api = new Api();

const FeedbackIdeasPage = () => {
    const [isLoading, setIsLodaing] = useState(true);
    const [accessible, setAccessible] = useState(false);
    const [boardHash, setBoardHash] = useState('');
    const [ssoToken, setSsoToken] = useState('');

    useEffect(() => {
        const fetchToken = async () => {
            setIsLodaing(true);
            try {
                const response = await api.getIdeoloBoardToken();
                if (response) {
                    setIsLodaing(false);
                }
                if (response?.accessible) {
                    setAccessible(response.accessible);
                }
                if (response?.ssoToken && response?.boardHash) {
                    setSsoToken(response.ssoToken);
                    setBoardHash(response.boardHash);
                }
            } catch (error) {
                setIsLodaing(false);
                console.error('Failed to fetch idea board token:', error);
            }
        };

        fetchToken();
    }, []);

    useEffect(() => {
        if (!ssoToken) return;

        const script = document.createElement('script');
        script.src = 'https://app.ideolo.co/widget/index.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [ssoToken]);

    if (isLoading) {
        return <p>Waiting for Ideolo</p>;
    }

    if (!accessible) {
        return (
            <ContentBox>
                <p style={{ margin: 0, textAlign: 'center' }}>
                    You don't have access the the Feedback & Ideas Board.
                </p>
            </ContentBox>
        );
    }

    if (!ssoToken || !boardHash) {
        return (
            <ContentBox>
                <p style={{ margin: 0, textAlign: 'center' }}>
                    Sorry but the Feedback & Ideas Board is temporarily
                    unavailable.
                    <br />
                    Please, try again in a few minutes.
                </p>
            </ContentBox>
        );
    }

    return (
        <>
            {accessible && ssoToken && boardHash && (
                <div
                    id="ideolo-board"
                    data-base-url="https://app.ideolo.co/"
                    data-board-hash={boardHash}
                    data-sso-token={ssoToken}
                    style={{
                        width: 'calc(100vw - 48px)',
                        maxWidth: '1280px',
                    }}
                />
            )}
        </>
    );
};

export default FeedbackIdeasPage;
